import { ADMIN_PREFIX } from "@cti-workspace/helpers";
import { postApi } from "./api";

export default async function addDatabaseConnection({ connectionName, connectionURL, active, dbl }) {
	const url = `/${ADMIN_PREFIX}/addDatabaseConnection`;
	return postApi(url, { connectionName, connectionURL, active, dbl });
}
